<template>
  <BaseModal>
    <div>
        <ul>
            <li>
                1. Встановлений відсоток кешбеку від вартості замовлення гості Вашого закладу будуть отримувати на їх бонусний рахунок від кожного виконаного замовлення.
            </li>
            <li>
                2. Якщо гість закладу має достатьно коштів на бонусному рахунку, він може повністю оплатити своє замовлення. В такому випадку, вартість замовлення буде списана з його бонусного рахунку та переведена на Ваш баланс в системі QRWaiter. 
            </li>
            <li>
                3. Бонусний рахунок єдиний для клієнта і працює одночасно в усіх закладах з підключеною системою лояльності.
            </li>
        </ul>
    </div>
    <p class="comment c-grey">
        &copy; Програма лояльності, QRWaiter 2020
    </p>
    <div class="terms-controls">
        <button class="round-button round-button-green agree-button" @click="onAgree">
            З умовами погоджуюсь
        </button>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/modals/BaseModal.vue'

export default {
    components: {
        BaseModal
    },
    methods: {
        onAgree() {
            this.$emit('agree');
        }
    }
}
</script>

<style scoped>
.terms-controls {
    margin-top: 1vh;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
}

.agree-button {
    width: 30vh;
}

ul {
    list-style-type: none;
}

li {
    margin-top: 1vh;
    font-size: 1.7vh;
}
</style>